import React from 'react';

function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-white px-4 py-12 text-center">
      {Icon && (
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-forge-50 text-forge-600">
          <Icon className="h-6 w-6" aria-hidden />
        </div>
      )}
      <p className="text-content-primary font-medium">{title}</p>
      {description && (
        <p className="text-content-muted text-sm mt-2 max-w-sm mx-auto">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export default EmptyState;
